import { render } from "./LbrxTicketStatus.vue?vue&type=template&id=27572855&scoped=true"
import script from "./LbrxTicketStatus.vue?vue&type=script&lang=js"
export * from "./LbrxTicketStatus.vue?vue&type=script&lang=js"

import "./LbrxTicketStatus.vue?vue&type=style&index=0&id=27572855&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27572855"]])

export default __exports__